import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

const SideBarItem = ({ item, active }) => {
  return (
    <Link
      to={item.path}
      className={active ? "sidebar-item-active" : "sidebar-item"}
    >
      <div className="sidebar-item-icon-wrapper">
        {item.icon ? (
          <img
            src={item.icon}
            alt={`icon-${item.title}`}
            className="sidebar-item-icon"
          />
        ) : (
          <div className="sidebar-item-icon-placeholder"></div>
        )}
      </div>
      <span className="sidebar-item-label">{item.title}</span>
    </Link>
  );
};

export default SideBarItem;